export const comments_3249781 = {"data":{"data":[],"links":{}}}